export default {
    state: {
        dicts: [],
    },
    getters: {
        getCategoryTop: state => group => {
            return state.dicts.filter(item => {
                return (item.group === group && item.pid === 0)
            });
        },
        getCategoryChild: state => pcode => {
            return state.dicts
                .filter(item => item.pcode === pcode);
        },
        getCategoryById: state => id => {
            return state.dicts.find(item => {
                return item.id === id;
            })
        }
    },
    mutations: {
        setDicts(state, val) {
            Object.assign(state.dicts, val);
        },
    },
    actions: {
        async getDictsCategorys({ commit, state }) {
            return new Promise(resolve => {
                if (state.dicts && state.dicts.length > 0) {
                    resolve(state.dicts);
                } else {
                    this.$axios.get("/json/js_category.json").then(list => {
                        commit("setDicts", list);
                        resolve(list);
                    });
                }
            });
        },
        // async getProductList({ commit, state }) {
        //     return new Promise(resolve => {
        //         this.$axios.get("/json/person_productlist.json").then(list => {
        //             // commit("setProducts", list);
        //             resolve(list);
        //         });
        //     });
        // },

    }
}
